import type { PredictiveAlert } from '@/lib/api/tickets.js';

const STORAGE_KEY = 'fixflow_predictive_alerts';
const DISMISS_KEY = 'fixflow_predictive_alerts_dismissed';

type AlertStore = Record<string, PredictiveAlert[]>;

function readAlerts(): AlertStore {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as AlertStore;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function readDismissed(): Record<string, true> {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, true>;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function savePredictiveAlerts(ticketId: string, alerts: PredictiveAlert[]) {
  if (!alerts.length) return;
  const store = readAlerts();
  store[ticketId] = alerts;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}

export function getPredictiveAlerts(ticketId: string): PredictiveAlert[] {
  if (readDismissed()[ticketId]) return [];
  return readAlerts()[ticketId] ?? [];
}

export function dismissPredictiveAlerts(ticketId: string) {
  const dismissed = readDismissed();
  dismissed[ticketId] = true;
  localStorage.setItem(DISMISS_KEY, JSON.stringify(dismissed));
}
